import React, {useState, useEffect, useCallback, useRef} from 'react'
import {Radio, Input, InputNumber, Image, message, Button, Space} from 'antd'
import {CloseOutlined} from '@ant-design/icons'
import AvatarUploader, {FileUploader} from "../../../components/Uploader";
import DraggableModal from "../../../components/DraggableModal";
import Api from "../../../api";
import {emptyValidate} from "../../../util/validate";
import CoverUploader from "../../../components/Uploader";

export default function CourseModal({onClose,onRemove, isShow, params}) {
    const [isOpen, setIsOpen] = useState(false)
    const [title, setTitle] = useState()
    const [coverImg, setCoverImg] = useState()

    const [typeCode, setTypeCode] = useState(1)
    const [imgList, setImgList] = useState([])
    const [filePath, setFilePath] = useState()
    const [minutes, setMinutes] = useState(0)
    const [seconds, setSeconds] = useState(0)
    const videoRef = useRef()
    const [loading, setLoading] = useState(false)


    useEffect(() => {
        if (isShow) {
            setTitle(params.courseInfoName)
            if (params.courseInfoId) {
                setTypeCode(params.typeCode)
                if (params.typeCode === 1) {
                    setFilePath(params.filePath)
                    setMinutes(Math.floor(params.totalNumber/60))
                    setSeconds(params.totalNumber % 60)
                    setCoverImg(params.coverImg)
                } else {
                    setImgList(params.filePath ? params.filePath.split('|') : [])
                }
            } else {
                setTypeCode(1)
                setImgList([])
                setFilePath()
                setMinutes(0)
                setSeconds(0)
                setCoverImg()
            }
        }
        setIsOpen(isShow)
    }, [isShow])

    const onTypeChange = useCallback((e) => {
        setTypeCode(e.target.value)
    })
    const onImgUploader = useCallback(url => {
        setImgList([url, ...imgList])
    })
    const onDeleteImg = useCallback(i => {
        imgList.splice(i, 1)
        setImgList([...imgList])
    })

    const onFileUploader = useCallback(url => {
        setFilePath(url)
        loadDuration()
    })
    const loadDuration = useCallback(()=>{
        let inst = setInterval(() => {
            if (videoRef.current && videoRef.current.duration) {
                clearInterval(inst)
                let duration = Math.ceil(videoRef.current.duration)
                setMinutes(Math.floor(duration / 60))
                setSeconds(duration % 60)
            }
        }, 1000)
    })

    const onCover = useCallback((url)=>{
        setCoverImg(url)
    })

    const save = useCallback(() => {
        let validateResult = emptyValidate(title, '请填写课程标题！')
        || emptyValidate(filePath||imgList.length, '请上传课程内容！');
        if (typeCode === 1) {
            validateResult = validateResult || emptyValidate(coverImg, '请上传课程封面！')
        }

        if (validateResult) {
            return;
        }

        let data = {
            courseId: params.courseId,
            parentId: params.parentId,
            dicLevel: params.dicLevel,
            courseInfoName: title,
            typeCode,
            coverImg,
            filePaths: typeCode === 1 ? [filePath] : imgList,
            totalNumber: typeCode === 1 ? minutes * 60 + seconds : imgList.length,
            courseInfoId: params.courseInfoId
        }
        setLoading(true)
        Api.createUpdateCourseInfo(data).then(resp => {
            if (!data.courseInfoId) {
                data.courseInfoId = resp.info
                data.sort = 0
            }
            data.filePath = data.filePaths.join('|')
            onClose(data)
            setLoading(false)
        })
    })

    const deleteInfo = useCallback(()=>{
        Api.deleteCourseInfo(params.courseInfoId,params.courseId).then(resp=>{
            if (resp.resultCode ===1) {
                message.success(resp.resultMessage)
                onRemove && onRemove(params.courseInfoId)
                onClose()
            }
        })
    })

    return (
        <DraggableModal
            title="课程编辑"
            open={isOpen}
            onOk={save}
            onCancel={() => onClose()}
            width={680}
            okText="保存"
            footer={null}
            maskClosable={false}
        >
            <div className="white-bg mgt32 pdb40 pdh32">
                <div>
                    <span className="required bold">课程标题：</span>
                    <Input style={{width: 480}} value={title} maxLength={80} onChange={(e) => setTitle(e.target.value)}/>
                </div>
                <div className="mgt20">
                    <span className="required bold">课程形式：</span>
                    <Radio.Group value={typeCode} onChange={onTypeChange}>
                        <Radio.Button value={1}>视频</Radio.Button>
                        <Radio.Button value={2}>图片</Radio.Button>
                    </Radio.Group>
                </div>
                {typeCode === 1 && <div className="pdv12 mgt14">
                    <div className="required bold">上传课程： <FileUploader onResult={onFileUploader}/></div>
                    <div className="gray mgt12" style={{paddingLeft: 72}}>支持扩展名：仅支持mp4格式</div>
                    {filePath && <div className="relative white-light-bg mgt12"
                                      style={{marginLeft: 72, width: 200, height: 120}}>
                        <video src={filePath}
                               ref={videoRef}
                               controls
                               preload="auto"
                               style={{width: 200, height: 120}}
                               poster={filePath + "?spm=qipa250&x-oss-process=video/snapshot,t_7000,f_jpg,w_800,h_450,m_fast"}
                        />
                        <CloseOutlined className="absolute cursor" onClick={() => setFilePath()}
                                       style={{top: 0, right: 0}}/>
                    </div>}
                    <div className="flexbox align-center mgt20">
                        <span className="bold required">视频时长：</span>
                        <InputNumber
                            type="number"
                            min={0}
                            max={200}
                            value={minutes}
                            onChange={(val) => setMinutes(val)}
                            style={{width: 80, height: 32}}/>
                        <span className="mgl6 mgr4">分</span>
                        <InputNumber
                            type="number"
                            min={0}
                            max={59}
                            value={seconds}
                            onChange={(val) => setSeconds(val)}
                            style={{width: 80, height: 32}}/>
                        <span className="mgl6">秒</span>
                    </div>
                    <div className="flexbox align-center mgt20">
                        <div className="required bold">课程封面：</div>
                        <div className="pdv12">
                            <CoverUploader type={2} onResult={onCover}>
                                {coverImg&& <Image src={coverImg} preview={false} style={{width: 200, height: 120}} />}
                            </CoverUploader>
                            <div className="gray">支持jpg、png、jpeg格式，尺寸为800px *450px</div>
                        </div>
                    </div>
                </div>}
                {typeCode === 2 && <div className="pdv12 mgt20">
                    <div className="mgb8 required bold">上传课程：</div>
                    <AvatarUploader onResult={onImgUploader}/>
                    <div className="gray">支持jpg、png、jpeg格式，尺寸为600px *600px</div>
                    <div className="mgt20">
                        {imgList.map((imgPath, i) => <div className="relative mgr12 mgb12 inline-block" key={imgPath}>
                            <Image
                                className="border-radius"
                                width={128}
                                height={80}
                                src={imgPath}
                            />
                            <CloseOutlined className="absolute cursor" onClick={() => onDeleteImg(i)}
                                           style={{top: 6, right: 6}}/>
                        </div>)}
                    </div>
                </div>}
            </div>
            <div className="flexbox justifyBetween mgt24">
                {params.courseInfoId ? <Button
                    key="delete"
                    danger
                    onClick={deleteInfo}
                >
                    删除
                </Button>:<span></span>}
                <Space>
                    <Button key="cancel" onClick={()=>onClose()}>
                        取消
                    </Button>
                    <Button key="submit" type="primary" loading={loading} onClick={save}>
                        保存
                    </Button>
                </Space>
            </div>
        </DraggableModal>)
}




